<div>
  <span class="flex">
      <label class="{{labelClasses}} {{required ? requiredClasses : ''}}" *ngIf="label"
             [ngClass]="{ disabled: isDisabled }">{{ label }}</label>
      <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                     [sizeInPx]="infoIconSize"></psc-info-icon>
  </span>
  <input
    #addresstext
    class="{{inputClasses}}"
    name="place"
    type="text"
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    [placeholder]="'placeholders.address_input' | transloco"
    [disabled]="isDisabled"/>
  <psc-input-error
    [control]="formControl"></psc-input-error>
</div>
